import logoStepUp from "../assets/img/teacher1.png"
import logoTeenLeader from "../assets/img/teacher2.png"
import logoShiningStart from "../assets/img/teacher3.png"
import courseYellow from "../assets/img/course-yellow.png"
import coursePink from "../assets/img/course-pink.png"
import courseBlue from "../assets/img/course-blue.png"

export const stepUp =
{
    name: 'STEP UP',
    subName: 'TIẾNG ANH MẦM NON',
    sortDescription: 'NỀN TẢNG ANH NGỮ VỮNG CHẮC',
    hashDescription_1: 'WINDSOR CENTER mang đến một cách tiếp cận mới trong việc học tiếng Anh: môi trường học tương tác, những hoạt động thú vị, tập trung phát triển 4 kỹ năng Nghe - Nói - Đọc Viết.',
    hashDescription_2: 'Bé sẽ được tiếp xúc với ngôn ngữ một cách tự nhiên nhất và tự tin chinh phục các kỳ thi quốc tế. ',
    image: logoStepUp,
    colorPage: '#ffd535',
    bannerIn: courseYellow,
    colorText:'#72bcca',
    colorText1:'#000'
}
export const teenLeaders =
{
    name: 'TEEN LEADERS',
    subName: 'TIẾNG ANH THIẾU NIÊN',
    sortDescription: 'XUẤT SẮC IELTS, KET, PET',
    hashDescription_1: 'Chương trình Teen Leaders tập trung vào phát triển khả năng Anh ngữ và sự tự tin của học viên ở cả bốn kỹ năng. Giáo trình học tiêu chuẩn quốc tế từ National Geographic giàu hình ảnh, video và những đề tài hiện đại phù hợp với độ tuổi học viên. Teen Leaders sử dụng Phương pháp học tư duy, giúp học viên có trải nghiệm học tập thú vị bên cạnh việc biết sử dụng tiếng Anh ở nhiều ngữ cảnh thực tế khác nhau.',
    hashDescription_2: '',
    image: logoTeenLeader,
    colorPage: '#ad187c',
    bannerIn:coursePink,
    colorText:'#e3953d',
    colorText1:'#fff'
}

export const shiningstarts = {
    name: 'SHINING STARS',
    subName: 'Tiếng anh thiếu nhi',
    sortDescription: 'Kết quả tối ưu kỳ thi Anh ngữ quốc tế Cambridge',
    hashDescription_1: 'Chương trình giảng dạy tập trung phát triển 4 kỹ năng: Nghe, Nói, Đọc và Viết. Giáo viên sử dụng phương pháp tương tác vào quá trình học tập thông qua các hoạt động vui chơi & các bài tập thú vị giúp học viên sử dụng thành thạo tiếng Anh ở nhiều ngữ cảnh khác nhau và tự tin chinh phục các kỳ thi Cambridge.',
    hashDescription_2: 'Tất cả các khóa học Shining Stars tại WINDSOR CENTER được thiết kế để tối đa hóa điểm thi Cambridge YLE của học sinh một cách hiệu quả.',
    image: logoShiningStart,
    colorPage: '#3cbac8',
    bannerIn:courseBlue,
    colorText:'#fad448',
    colorText1:'#fff'
}

export const englishcommunication = {
    // 
}